/* eslint-disable no-unused-vars */
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactCountryFlag from 'react-country-flag';
import { campaignReportsActions } from 'store/actions';
import { CheckboxInner, ParagraphWithTooltip, CopyString, IconButton } from 'components';
import { Palette } from 'config';
import { DotsMenu } from './components/dotsMenu/DotsMenu';
import { Pause, Start, Pen } from 'assets/icons';
import { AppStatus } from './components/appStatus/AppStatus';
import { IsBulkActions } from './components/isBulkActions/IsBulkActions';

import * as S from './LeftSideRow.styled';

const Applications = ({ item }) => {
  const showAppName = useSelector((state) => state.auth.show_app_name);
  const dispatch = useDispatch();

  const handleCheckbox = useCallback(({ item, selectedTableItems }) => {
    let newValue;
    if (selectedTableItems.some((el) => item.pba_id === el.pba_id)) {
      newValue = selectedTableItems.filter((el) => item.pba_id !== el.pba_id);
    } else {
      newValue = [...selectedTableItems, item];
    }
    dispatch(
      campaignReportsActions.updateProperty({
        propField: 'selectedTableItems',
        newValue: newValue,
      }),
    );
  }, []);

  return (
    <S.TableBox>
      <S.IconWrap>
        <IsBulkActions
          item={item}
          env='app'
          handleCheckbox={handleCheckbox}
          uniqueField='pba_id'
          name={item.pba_id}
          id={item.pba_id}
        />
      </S.IconWrap>
      <AppStatus
        appStatus={item.appStatus}
        pb_status_id={item.pb_status_id}
        recommended_bid={item.recommended_bid}
        saved_min_bid={item.saved_min_bid}
      />
      <S.TextBox>
        <ParagraphWithTooltip
          text={showAppName ? item?.Apps ?? '' : `ID: ${item?.pba_number ?? ''}`}
          style={{ fontSize: '14px', fontWeight: '500' }}
        />
        {showAppName && (
          <ParagraphWithTooltip
            text={item?.package ?? ''}
            style={{ fontSize: '12px', fontWeight: '400' }}
          />
        )}
        {showAppName && (
          <CopyString
            label='ID'
            text={item?.pba_number?.toString() || 'test'}
            className='publisherReportTableNameColCopyString'
          />
        )}
      </S.TextBox>
    </S.TableBox>
  );
};

const Date = ({ item }) => {
  // fix of a rare case when data comes empty
  // TO-DO handle stale state
  //if (!item?.Date) return null;
  const [day, month, year] = item.Date.split('-');

  return (
    <S.TableBox>
      <S.IconWrap></S.IconWrap>
      <S.DateParagraph>{`${day}/${month}/${year}`}</S.DateParagraph>
    </S.TableBox>
  );
};

const Country = ({ item }) => {
  const countryCode = item.CountryCode === 'UK' ? 'GB' : item.CountryCode;

  return (
    <S.TableBox>
      <S.IconWrap></S.IconWrap>
      <S.DateParagraph>
        <ReactCountryFlag
          countryCode={countryCode}
          svg
          style={{
            width: '20px',
            height: '15px',
            marginRight: '8px',
          }}
        />
        {`${item.CountryCode} - ${item.Country}`}
      </S.DateParagraph>
    </S.TableBox>
  );
};

const Creative = ({ item }) => {
  const { title, id } = extractTitleAndId(item?.Creative);

  const dispatch = useDispatch();

  // fix of stale data 2,.,,
  // TO-DO handle stale state
  //if (!title || !id) return null;

  const handleCheckbox = useCallback(({ item, selectedTableItems }) => {
    let newValue;
    if (selectedTableItems.some((el) => item.bn_bannerId === el.bn_bannerId)) {
      newValue = selectedTableItems.filter((el) => item.bn_bannerId !== el.bn_bannerId);
    } else {
      newValue = [...selectedTableItems, item];
    }
    dispatch(
      campaignReportsActions.updateProperty({
        propField: 'selectedTableItems',
        newValue: newValue,
      }),
    );
  }, []);

  return (
    <S.TableBox>
      <S.IconWrap>
        <IsBulkActions
          item={item}
          env='creative'
          handleCheckbox={handleCheckbox}
          uniqueField='bn_bannerId'
          name={item.bn_bannerId}
          id={item.bn_bannerId}
        />
        {/* {isBulkActions && id && (
          <S.CheckboxWrap>
            <CheckboxInner
              name={'test'}
              isChecked={selectedTableItems.some((el) => item.bn_bannerId === el.bn_bannerId)}
              id={id}
              onChange={() => handleCheckbox({ item, selectedTableItems })}
            />
          </S.CheckboxWrap>
        )}
        {!isBulkActions && <DotsMenu {...item} env='creative' />} */}
      </S.IconWrap>
      {item.bn_status === 0 && <Start />}
      {item.bn_status === 1 && <Pause />}
      <S.TextBox>
        <ParagraphWithTooltip text={`${title}`} style={{ fontSize: '14px', fontWeight: '500' }} />
        <ParagraphWithTooltip
          text={`${item?.package ?? ''}`}
          style={{ fontSize: '12px', fontWeight: '400' }}
        />
        {<CopyString label='ID' text={id} className='campaignReportTableNameColCopyString' />}
      </S.TextBox>
    </S.TableBox>
  );
};

function extractTitleAndId(string) {
  if (!string) return { title: '', id: '' };

  const pattern = /^(.*?)<br\s*\/?>.*?Banner\s*ID:\s*(\d+)/;
  const match = string.match(pattern);

  const title = match ? match[1] : '';
  const id = match ? match[2] : '';

  return { title, id };
}

export const LeftSideRow = {
  Apps: Applications,
  Date: Date,
  Country: Country,
  Creative: Creative,
};
